import { FormControl, InputLabel, Select as MuiSelect } from "@mui/material";

export const SelectMap = (props) => {
    return (
        <FormControl fullWidth size='small' disabled={props.disabled || false} style={props.style}  >
            <InputLabel>{props.label}</InputLabel>
            <MuiSelect
                readOnly={props.readOnly}
                value={props.value}
                label={props.label}
                onChange={props.onChange}
            >
                {props.children}
            </MuiSelect>
        </FormControl>
    );
}       